import request from '@/utils/request'

/**
 * TODO： name, id
 * 设备类型: 30b4628615834cd2a4d72d0373d525bc
 * 车辆类型: d65a9df0eace470a8b60e2e0e601721b
 * 车牌颜色: c3d7462926ba4e169999026593f40ce0
 * 车牌组使用场景： 874cfc2a1dbe476a8923c94411715722
 * 渠道商: ca5447b2515e4354989eb5b5cdcc8f88
 * 广告投放位置: 5c6283a4c4bd4fd1842030500b704b9b
 * 岗位类型 : dae93f2fd7cd4df999d32f8750fa6a1e
 */

/**
 * 获取字典数据
 * @param key
 * @returns {*}
 */
export function selector(key) {
  return request({
    url: `/api/system/Base/DictionaryData/${key}/Data/Selector`,
    method: 'get'
  })
}

/**
 * 字典
 * @param key
 * @returns {*}
 * @constructor
 */
export function dictDataInterface(key) {
  return request({
    url: `/api/system/DataInterface/${key}/Actions/Response`,
    method: 'get'
  })
}

/**
 * 根据code获取数据字典信息
 * @param code
 * @returns {*}
 * @constructor
 */
export function getListByTypeDataCode(code) {
  return request({
    url: `/api/system/Base/DictionaryData/getListByTypeDataCode/${code}`,
    method: 'get'
  })
}

/**
 * 获取字典分类
 * @param {Object} params - 可选筛选参数 { name, enCode }
 * @returns {*}
 * @constructor
 */
export function getDictionaryType(params) {
  return request({
    url: `/api/system/Base/DictionaryType`,
    method: 'get',
    params
  })
}

/**
 * 获取字典分类信息
 * @returns {*}
 * @constructor
 */
export function getDictionaryInfoById(id) {
  return request({
    url: `/api/system/Base/DictionaryData/${id}`,
    method: 'get'
  })
}

/**
 * 添加字典分类
 * @returns {*}
 * @constructor
 */
export function addDictionaryType(data) {
  return request({
    url: `/api/system/Base/DictionaryType`,
    method: 'POST',
    data: data
  })
}

/**
 * 字典分类信息
 * @returns {*}
 * @constructor
 */
export function getDictionaryTypeInfo(id) {
  return request({
    url: `/api/system/Base/DictionaryType/${id}`,
    method: 'get'
  })
}

/**
 * 修改字典分类信息
 * @returns {*}
 * @constructor
 */
export function updateDictionaryTypeInfo(data) {
  return request({
    url: `/api/system/Base/DictionaryType/${data.id}`,
    method: 'put',
    data: data
  })
}

/**
 * 添加字典数据
 * @returns {*}
 * @constructor
 */
export function addDictionaryData(data) {
  return request({
    url: `/api/system/Base/DictionaryData`,
    method: 'POST',
    data: data
  })
}

/**
 * 获取数据字典信息
 * @returns {*}
 * @constructor
 */
export function getDictionaryDataInfo(id) {
  return request({
    url: `/api/system/Base/DictionaryData/${id}/Info`,
    method: 'get'
  })
}

/**
 * 修改数据字典信息
 * @returns {*}
 * @constructor
 */
export function updateDictionaryData(data) {
  return request({
    url: `/api/system/Base/DictionaryData/${data.id}`,
    method: 'put',
    data: data
  })
}

/**
 * 删除字典分类
 * @returns {*}
 * @constructor
 */
export function delDictionaryType(id) {
  return request({
    url: `/api/system/Base/DictionaryType/${id}`,
    method: 'DELETE'
  })
}

/**
 * 删除字典数据
 * @returns {*}
 * @constructor
 */
export function delDictionaryData(id) {
  return request({
    url: `/api/system/Base/DictionaryData/${id}`,
    method: 'DELETE'
  })
}

